import React, { Suspense, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Outlet, Link, useNavigate, useParams } from "react-router-dom";
import { useQuery } from '@tanstack/react-query';
import { getIni } from '../services';
import {setIni} from '../state/reducers/main'
import LoadingMod from './LoadingMod';

const LayoutPublic = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { isLoading, data, refetch, isError } = useQuery({
        queryKey: ['initialState'],
        queryFn:  async () => {
			const data = await getIni()
            dispatch(setIni(data))
            return data;
		},
        //refetchInterval: 300000 //300000,//5min
        staleTime: 1000 * 5 , // 5seg
		cacheTime: 1000 * 5 , // 5seg
		//enabled: true,
        }
    );

    useEffect(() => {
        console.log("LAYOUT")
    }, [])

    return <>
    {isLoading ? 
        <LoadingMod />
    :
    <Suspense fallback={ <LoadingMod />}>
        <Outlet />
    </Suspense>
    }
    </>
}

export default LayoutPublic